module.exports = __webpack_public_path__ + "img/grayBackArrow.6e0e3f26.svg";